import CryptoJS from 'crypto-js';

export function md5(inputString) {

    return CryptoJS.MD5(inputString).toString(CryptoJS.enc.Hex);
}